export type Brand = "tokyotreat" | "sakuraco" | "yumetwins" | "nomakenolife";

export const brands: Brand[] = [
  "tokyotreat",
  "sakuraco",
  "yumetwins",
  "nomakenolife",
];

export const selectBrands = brands.map((brand) => ({
  value: brand,
  label: brand.charAt(0).toUpperCase() + brand.slice(1),
}));

export const colorsByBrand: Record<Brand, string> = {
  tokyotreat: "orange",
  sakuraco: "yellow",
  yumetwins: "violet",
  nomakenolife: "pink",
};
